import { createSlice } from "@reduxjs/toolkit";

const initalState = {
  selectedTheme: null, // filtering that we selected from the dropdown 
  selectedFeatures: [], // filtering
  selectedGroups: [], // filtering
  selectedSharedUid: null, // that we selected from the dropdown (website shared_uid)
  selectedSite: null, //this is URL query parameter 
  selectedWebsiteName: null, // that we selected from the dropdown (website name)
  designThemesData: [], // Theme List that shows all themes in a table
  designTemplatesDataTheme: [], // Templates list
  siteOptions: [], // Website List with ids and names
  selectedThemeShareuid: null,
  selectedSiteURL : null,
  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: "modified",
    direction: "desc",
  },
  widgetStructures: [], // Widget structures data
};

const themeSlice = createSlice({
  name: "theme",
  initialState: initalState,
  reducers: {
    setSelectedFeatures: (state, action) => {
      state.selectedFeatures = action.payload;
    },
    setSelectedGroups: (state, action) => {
      state.selectedGroups = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setDesignThemesData: (state, action) => {
      state.designThemesData = action.payload;
    },
    setDesignTemplatesDataTheme: (state, action) => {
      state.designTemplatesDataTheme = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setSelectedThemeShareuid: (state, action) => {
      state.selectedThemeShareuid = action.payload;
    },
    setSelectedTheme: (state, action) => {
      state.selectedTheme = action.payload;
    },
    setSelectedSiteURL: (state, action) => {
      state.selectedSiteURL = action.payload;
    },
    setSelectedWebsiteName: (state, action) => {
      state.selectedWebsiteName = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setWidgetStructures: (state, action) => {
      state.widgetStructures = action.payload;
    },
  },
});

export const {
  setSelectedFeatures,
  setSelectedGroups,
  setSelectedSharedUid,
  setSelectedSite,
  setDesignThemesData,
  setDesignTemplatesDataTheme,
  setSiteOptions,
  setSelectedThemeShareuid,
  setSelectedSiteURL,
  setSelectedWebsiteName,
  setPage,
  setSort,
  setSelectedTheme,
  setRowsPerPage,
  setWidgetStructures,
} = themeSlice.actions;
export default themeSlice.reducer;
